import React from 'react';
import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';
import { DefaultRootHeader } from '@rsos/ellington';
import { TimeAgo as DisconnectedTimeAgo, default as TimeAgo } from './TimeAgo';

const StyledSubHeader = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
  lineHeight: 1.5,
})``;

const CustomCardHeader = ({
  dataPath,
  selectedCallerID,
  createdTime,
  description,
  ...rest
}) => {
  return (
    <DefaultRootHeader {...rest}>
      <StyledSubHeader>
        {description && <>{description}, </>}
        {dataPath && selectedCallerID ? (
          <TimeAgo dataPath={dataPath} selectedCallerID={selectedCallerID} />
        ) : createdTime ? (
          <DisconnectedTimeAgo timestamp={createdTime} />
        ) : (
          <></>
        )}
      </StyledSubHeader>
    </DefaultRootHeader>
  );
};

export default CustomCardHeader;
